<!-- Responsibility: Implement player profile attributes behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->

<player-profile-attributes>
  <section class="pp-section" if={ props.attributes && props.attributes.length }>
    <h5 class="pp-section-title">ATTRIBUTES</h5>
    <div class="pp-grid">
      <stat-badge
        each={ entry in props.attributes }
        stat-key={ entry.key }
        value={ entry.value }
        desc={ entry.desc }
        meta={ entry.meta }
      ></stat-badge>
    </div>
  </section>

  <script>
    import StatBadge from '../components/stat-badge.riot'
    export default { components: { StatBadge } }
  </script>

  <style>
    .pp-section { animation: section-in 0.5s ease both; }
    .pp-section-title {
      color: var(--text-dim); font-size: var(--space-sm); letter-spacing: 0.25em; margin: 0 0 1.25rem; border-bottom: 1px solid var(--border); padding-bottom: var(--space-xs);
    }
    .pp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr)); gap: var(--space-md); }
    @media (max-width: 40.625rem) { .pp-grid { grid-template-columns: 1fr; } }
  </style>
</player-profile-attributes>
